module.exports = __webpack_public_path__ + "media/images/bg-whatwedo-sp-a94c6f4e30c56dd419d2bbeea9e5a693.jpg";